<template>
	<div>
		<buttonlist
			@help="help"
			@opentable="opentable"
			@search="search"
			@reflash="reflash"
			@exps="exps"
			ref="SetBtn"
		></buttonlist>
		<table>
			<tr>
				<td style="width:60px">{{ $t("getapi[1974]") }}</td>
				<td style="width:150px;">
					<el-select
							filterable
							v-model="dataDetail.year"
							size="mini"
							style="margin-righ:20px"
					>
						<el-option
								v-for="item in yearList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
						></el-option>
					</el-select>
				</td>
				<td>{{ $t("getapi[1975]") }}</td>
				<td>
					<el-select
							filterable
							v-model="dataDetail.month"
							size="mini"
							style="margin-righ:20px"
					>
						<el-option
								v-for="item in monthList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
						></el-option>
					</el-select>
				</td>
			</tr>
		</table>
		<div id="xpane-0">
			<vTable
					:data="dataSet"
					:loading="loading"
					queryData="finmachiningsfc"
					:filter_thousandth="['init_qty','init_price','init_material_cost','init_man_cost','init_charge_cost','in_qty','in_price','in_material_cost','in_man_cost',
					'in_charge_cost','out_qty','out_price','out_material_cost','out_man_cost','out_charge_cost','remain_qty','remain_price',
					'remain_material_cost','remain_man_cost','remain_charge_cost']"
					:header="tableHeader"
					:height="tableHeight"
					:checkflg="false"
					ref="singleTable"
			></vTable>
		</div>
		<ctable :isVisible="false" :title="$t('getapi[8539]')" queryData="finmachiningsfc" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_sfc',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight2,
                maxHeight: this.$windowSize.tableHeight2,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight2
        }
    },
	data() {
		return {
            tableHeader: [],
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            dataDetail:{
                year:'',
				month:''
			},
            monthList: [
                {
                    value: 1,
                    label: 1,
                },
                {
                    value: 2,
                    label: 2,
                },
                {
                    value: 3,
                    label: 3,
                },
                {
                    value: 4,
                    label: 4,
                },
                {
                    value: 5,
                    label: 5,
                },
                {
                    value: 6,
                    label: 6,
                },
                {
                    value: 7,
                    label: 7,
                },
                {
                    value: 8,
                    label: 8,
                },
                {
                    value: 9,
                    label: 9,
                },
                {
                    value: 10,
                    label: 10,
                },
                {
                    value: 11,
                    label: 11,
                },
                {
                    value: 12,
                    label: 12,
                },
            ],
            yearList: [],
            scrollTop:0,
		};
	},
    watch:{
        dataSet: function(){
            let that = this
            setTimeout(() => {
                that.$nextTick(function(){
                    that.$processdata.initForm(0)
                });
            }, 500);
        },
    },
	mounted: function() {
		let that = this;
		that.colsort()
		that.userData = sessionStorage.getItem('userData');
        let thisyear = new Date().getFullYear();
        for (let i = 0; i < 5; i++) {
            let obj = {
                value: thisyear - i,
                label: thisyear - i,
            };
            that.yearList.push(obj);
        }
        that.dataDetail.year = thisyear;
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('finmachiningsfc', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8539]"),this.$t("getapi[8538]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
		},
		// 查询
		search() {
			let that = this;
			that.getView()
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let parm = {
                Year: that.dataDetail.year,
                Month: that.dataDetail.month,
                Flg: 0
			}
			that.$http.urlpost('/CostCalc/InvView/GetFinMachining', parm, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.loading = false;
					that.authority();
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
        exps(){
            let that = this;
            let parm = {
                Year: that.dataDetail.year,
                Month: that.dataDetail.month,
                Flg: 0
            }
            that.$refs.SetBtn.SetOneBtnEnable('exps', false);
            that.$http.urlpost('/CostCalc/InvView/GetFinMachiningToExecl', parm, function(res) {
                that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                if (res.Success == 1) {
                    let hrefurl = Common.Url + res.DataContent.URL;
                    window.open(hrefurl);
                }
            });
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
